export default __webpack_public_path__ + "components/weather-icon/static/dayheavyrain-4bfaf814cd8c99192ebfca2cbdb32a3f.svg";